import { Country } from "@components/country/Country.types";
import { NumberType } from "./NumberType.types";
import { ServiceType } from "./ServiceType.types";
import { UseCase } from "./UseCase.types";
import { BillingProfiles } from "@components/billingProfiles/BillingProfiles.types";
import { BillingProfileId } from "@components/customer/BillingProfileId.types";

export const findName = (
  data: Country[] | NumberType[] | ServiceType[] | UseCase[],
  selectedId: string
) => {
  return data.find(({ id }) => id === selectedId)?.name;
};

export const findObject = (
  data: BillingProfiles[],
  selectedId: BillingProfileId
) => {
  return data.find(
    ({ id }) => JSON.stringify(id) === JSON.stringify(selectedId)
  );
};
